import React, {Component} from 'react';
import './TandCComponent.less';
import {TrackingContext} from '@homeaway/react-event-tracking';


class TandCComponent extends Component {
    constructor(props) {
        super(props);
    }


    handleClick = () => {
        this.context.trigger('generic.event', {eventaction: 'Term&Conditions.click', eventcategory: 'lex', eventlabel: 'ums'});
    }

    render = () => {
        const text = this.props.lingua.read('copyright');
        return (
            <div className = "TandCComponent text-center col-xs-12" onClick={this.handleClick}>
                <label dangerouslySetInnerHTML = {{__html: text}} />
            </div>
        );
    }
}
TandCComponent.contextType = TrackingContext;
export default TandCComponent;
